import '../styles.scss';
import { Assets } from '../../finder/components/Assets';
import { Button } from '@myua/kit';
import { AppLayout } from '../../app/components/AppLayout';
import { useSelector } from 'react-redux';
import { getData } from '../selectors';
import { ShareSharingButton } from './ShareSharingButton';
import { RoutedFullscreenPreview } from '../../fullscreenPreview/components/RoutedFullscreenPreview';
import { routes } from '../../router/model';
import filesize from 'filesize';
import { getAssetLabLogger } from '../../app/logs';
import { PageTabs } from '../../app/components/PageTabs';
import { downloadDOM } from '../../../../general/utils/download';
import { urlSharingDownload } from '../../../api';
import { Search } from '../../search/components/Search';
import { GoogleBulkButton } from '../../googleBulk/components/GoogleBulkButton';
import { GoogleBulkMode } from '../../googleBulk/model';
import { getUser } from '../../app/selectors';
import { EditButton } from './EditButton';
import { DetailsToggleButton } from '../../finder/components/DetailsToggleButton';

export const SharingPage = () => {
  const { sharing_link, total } = useSelector(getData);
  const assetLabLogger = useSelector(getAssetLabLogger);
  const user = useSelector(getUser);

  const title = sharing_link?.name ?? '';

  return (
    <AppLayout leftSider={true} rightSider={true}>
      <RoutedFullscreenPreview parentPath={routes.sharing} />
      <div className="al-sharing-page">
        <div className="al-sharing-page-top">
          <div className="al-sharing-page-top__title">
            <div className="al-sharing-page-top__title-text" title={title}>
              {title}
            </div>
          </div>

          <PageTabs />
          <DetailsToggleButton />
        </div>

        <div className="al-sharing-page-controls">
          <Button
            type="primary"
            disabled={!sharing_link || total.download.count === 0}
            onClick={
              sharing_link
                ? () => {
                    downloadDOM(urlSharingDownload(sharing_link.id));
                    assetLabLogger({
                      action: 'Sharing',
                      sub_action: 'Download',
                      extra: { text_1: sharing_link.id },
                    });
                  }
                : undefined
            }
          >
            Download {total.download.count === 0 ? null : `(${filesize(total.download.size)})`}
          </Button>
          {sharing_link ? (
            sharing_link.creator_id === user?.id ? (
              <EditButton />
            ) : (
              <ShareSharingButton sharingId={sharing_link.id} />
            )
          ) : null}
          <GoogleBulkButton mode={GoogleBulkMode.sharingAll} sharingId={sharing_link?.id} />
          <Search />
        </div>

        <Assets />
      </div>
    </AppLayout>
  );
};
